import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
// Self-hosted Inter (replaces the Google Fonts <link> that used to live in
// index.html) — the Google Fonts CSS endpoint serves a different response
// per User-Agent, which is fundamentally incompatible with Subresource
// Integrity (the browser can't pin a hash to content that legitimately
// varies), so `sonar:d30db226-4243-43de-ab21-20d05671839c` (Web:S5725) is
// resolved by removing the external, un-pinnable resource entirely rather
// than adding an integrity attribute that would break font loading for
// some browsers. Same weights the removed <link> requested (300-800).
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import './scss/index.scss';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
